/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Min_Event_Gap_Tolerance_LabelInputs */



/**
* | output |
* | --- |
* | "Minimum Event Gap Tolerance" |
*
* @param {Style_Guide_Manager_Min_Event_Gap_Tolerance_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_min_event_gap_tolerance_label = /** @type {((inputs?: Style_Guide_Manager_Min_Event_Gap_Tolerance_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Min_Event_Gap_Tolerance_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tolerance minimale de l'ecart d'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Minimale Ereignislückentoleranz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tolleranza minima del gap dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Минимальный допустимый разрыв между событиями")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tolerancia mínima de brecha de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最小事件间隙容差")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最小イベントギャップ許容値")
	if (locale === "hi") return /** @type {LocalizedString} */ ("न्यूनतम घटना अंतराल सहनशीलता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tolerância mínima de intervalo de eventos")
	return /** @type {LocalizedString} */ ("Minimum Event Gap Tolerance")
});